import { useContext, useState } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { Result } from "../shared/interfaces/Result";
import { ResultListRequestType } from "../shared/apiHandlers/ResultsAPIs";

export function useResultsList(resultType?: ResultListRequestType, callbacks?: QueryCallbacks<Result[]>) {
  const apiContext = useContext(ApiContext);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const query = useQuery({
    queryKey: ["resultsList", resultType],
    queryFn: async () => {
      if (resultType) {
        return await apiContext.resultsApis.getResultsList(resultType);
      }
    },
    onSuccess: callbacks?.onSuccess,
    onError: async (error: Response) => {
      if (callbacks?.onError) {
        callbacks.onError(error);
      }
      const errorText = await error.text();
      setErrorMessage(errorText);
    },
  });

  return { ...query, errorMessage };
}
